import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';

@Injectable({
  providedIn: "root"
})
export class DashboardContentieuxService {
  constructor(private _restClientService: RestClientService) {}

  nombreDossierContentieux() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-contentieux/nombre-dossier-contentieux-filtrer-Sur-periode"
    );
  }

  nombreDossierContentieuxProvions() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-contentieux/nombre-dossier-contentieux-provision-filtrer-Sur-periode"
    );
  }

  quantiteDossierContentieux() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-contentieux/quantite-dossier-contentieux-surLes6DerniersMois"
    );
  }
}
